import "./Sass/app.scss";
import { Route, Routes, useNavigate } from "react-router";
import Home from "./Components/Pages/Home";
import Lookup from "./Components/Pages/Lookup";
import Authenticated from "./Components/Pages/Authenticated";
import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { auth0Config } from "./Config/auth0Conifg";
import PublicLayout from "./Components/Layouts/PublicLayout";
import Events from "./Components/Pages/Events";
import PageResources from "./Components/Pages/Resources";
import Membership from "./Components/Pages/Membership";
import Redirecting from "./Components/Pages/Redirecting";
import CandidatePage from "./Components/Pages/Candidates";
import ResultsPage from "./Components/Pages/Results";
import { CLIENT_URL } from "./Config/constant";
import PageStyles from "./Components/Pages/Styles";
import History from "./Components/Pages/History";
import Disclaimer from "./Components/Tos/Disclaimer";
import Privacy from "./Components/Tos/Privacy";
import TermsOfService from "./Components/Tos/TermsOfService";

function App() {
  const navigate = useNavigate();
  const onRedirectCallback = (appState?: AppState | undefined) => {
    navigate(appState?.returnTo || "/", { replace: true });
  };

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        redirect_uri: CLIENT_URL,
        audience: auth0Config.audience,
      }}
    >
      <div className="app">
        <Routes>
          <Route index element={<Home />} />
          <Route path="redirecting" element={<PublicLayout />}>
            <Route index element={<Redirecting />} />
          </Route>
          <Route path="page" element={<PublicLayout container />}>
            <Route path="disclaimer" element={<Disclaimer />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="tos" element={<TermsOfService />} />
          </Route>
          <Route
            path="property-search"
            element={<PublicLayout withBackground hasAuth />}
          >
            <Route index element={<Lookup />} />
            <Route path="candidates" element={<CandidatePage />} />
            <Route path="results" element={<ResultsPage />} />
            <Route path="history" element={<History />} />
          </Route>
          <Route
            path="events"
            element={<PublicLayout withBackground container />}
          >
            <Route index element={<Events />} />
          </Route>
          <Route
            path="resources"
            element={<PublicLayout withBackground hasAuth />}
          >
            <Route index element={<PageResources />} />
          </Route>
          <Route
            path="membership"
            element={<PublicLayout withBackground hasAuth />}
          >
            <Route index element={<Membership />} />
          </Route>
          <Route path="authenticated" element={<Authenticated />} />
          <Route path="styles" element={<PageStyles />} />
        </Routes>
      </div>
    </Auth0Provider>
  );
}

export default App;
